import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { NavElem } from '../../_atoms/nav-elem/nav-elem.js';
import useInlineIcon from '../../../hooks/use-inline-icon/use-inline-icon.js';
import styles from '../dropdown.scss.js';
import { NAV_ELEMS } from '../../_atoms/nav-elem/types.js';

var bem = HoneyBem.init('dropdown-item', styles);
var DropdownItem = function (_a) {
  var extraClasses = _a.extraClasses,
    _b = _a.children,
    children = _b === void 0 ? '' : _b,
    RouterLink = _a.RouterLink,
    href = _a.href,
    _c = _a.active,
    active = _c === void 0 ? false : _c,
    InlineIcon = _a.InlineIcon,
    _d = _a.linkRef,
    linkRef = _d === void 0 ? {
      current: null
    } : _d,
    _e = _a.linkRest,
    linkRest = _e === void 0 ? {} : _e,
    _f = _a.Elem,
    Elem = _f === void 0 ? 'a' : _f,
    rest = __rest(_a, ["extraClasses", "children", "RouterLink", "href", "active", "InlineIcon", "linkRef", "linkRest", "Elem"]);
  return /*#__PURE__*/React__default__default.createElement("li", __assign({
    role: "presentation",
    className: bem.b(false, extraClasses)
  }, rest), /*#__PURE__*/React__default__default.createElement(NavElem, __assign({
    innerRef: linkRef,
    href: href || (linkRest === null || linkRest === void 0 ? void 0 : linkRest.to) || '',
    role: "menuitem",
    RouterLink: RouterLink,
    active: active,
    Elem: Elem,
    className: bem.e('link')
  }, linkRest), useInlineIcon(InlineIcon, active), children));
};
DropdownItem.displayName = 'DropdownItem';
DropdownItem.propTypes = {
  extraClasses: PropTypes__default.string,
  children: PropTypes__default.node,
  href: PropTypes__default.string,
  active: PropTypes__default.bool,
  linkRef: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.shape({
    current: PropTypes__default.oneOfType([PropTypes__default.element, PropTypes__default.object])
  })]),
  linkRest: PropTypes__default.object,
  Elem: PropTypes__default.oneOf(NAV_ELEMS)
};

export { DropdownItem, DropdownItem as default };
